<script>
import requestResetPassword from "@/api/request-reset-password";

export default {
	data() {
		return {
			username: "",
			email: "",
			forgotUsername: false,
			forgotEmail: true,
			errorMessage: ""
		};
	},
	methods: {
		resetPassword() {
			if (this.forgotEmail && !this.username) {
				return this.errorMessage = "* Username is empty";
			} else if (this.forgotUsername && !this.email) {
				return this.errorMessage = "* Email is empty";
			}
			requestResetPassword({
				user: this.username,
				email: this.email
			})
				.then(() => {
					this.errorMessage = "If the user is registered in the system, a password reset email will be sent.";
				})
				.catch(() => {
					this.errorMessage = "An error occured while trying to request password-reset.";
				});
		},
		setForgotUsername() {
			this.resetValues();
			this.forgotUsername = true;
			this.forgotEmail = false;
		},
		setforgotEmail() {
			this.resetValues();
			this.forgotUsername = false;
			this.forgotEmail = true;
		},
		resetValues() {
			this.errorMessage = "";
			this.username = "",
			this.email = "";
		}
	}
};
</script>

<template>
	<v-app id="inspire">
		<v-main>
			<v-container fluid fill-height>
				<v-layout align-center justify-center>
					<v-flex xs12 sm8 md5>
						<v-card class="elevation-12 box">
								<h1 class="z-title">Reset Login</h1>

								<v-form @submit.prevent="resetPassword">
									<v-text-field
										v-show="forgotEmail"
										v-model="username"
										label="Username"
										prepend-inner-icon="person"
										outlined
										type="text"
									/>
									<v-text-field
										v-show="forgotUsername"
										v-model="email"
										label="Email"
										prepend-inner-icon="email"
										outlined
										type="text"
									/>

									<a
										@click="setForgotUsername"
										v-if="!forgotUsername && forgotEmail"
									>
										I forgot my username
									</a>
									<a
										@click="setforgotEmail"
										v-else
									>
										I forgot my email
									</a>

									<v-btn
										block
										large
										type ="submit"
										color="primary"
									>Reset Password</v-btn>

									<div
										class="warningMessage"
										color="warning"
									>
										{{errorMessage}}
									</div>
								</v-form>

								<router-link
									:to="{name: 'login'}"
									color="primary"
								>
									Back to login
								</router-link>
							</div>
						</v-card>
					</v-flex>
				</v-layout>
			</v-container>
		</v-main>
	</v-app>
</template>

<style lang="scss" scoped>
.v-main {
	background-color: rgba(10, 10, 10, 0.86);
}
.box {
	padding: 20px;
	.z-title {
		color: #1a1a1a;
		font-size: 48px;
		line-height: 1;
		font-weight: 300;
		word-break: break-word;
		margin-bottom: 10px;
	}
	.v-btn {
		text-transform: capitalize;
		font-size: 22px;
		font-weight: normal;
		margin-top: 16px;
	}
	a {
		text-decoration: none;
	}
	.warningMessage {
		padding: 5px;
	}
	.left-side, .right-side {
		width: 50%;
		padding: 10px;
	}
	.right-side {
		text-align: center;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/views/ResetPassword.vue